import React, { useEffect, useRef, useState } from 'react';
import { useAuth } from '../lib/AuthContext.jsx';

// The Google Identity Services client ID is public (it's meant to be
// embedded in frontend code) -- it's baked in at build time via Vite env,
// not a Doppler secret. Set VITE_GOOGLE_OAUTH_CLIENT_ID in the frontend
// build environment.
const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_OAUTH_CLIENT_ID;

export default function Login() {
  const { signInWithGoogle } = useAuth();
  const [error, setError] = useState(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    if (!window.google || !GOOGLE_CLIENT_ID) return;

    window.google.accounts.id.initialize({
      client_id: GOOGLE_CLIENT_ID,
      callback: async (response) => {
        try {
          await signInWithGoogle(response.credential);
        } catch (err) {
          setError(err.message || 'Sign-in failed');
        }
      },
    });
    window.google.accounts.id.renderButton(buttonRef.current, {
      theme: 'outline',
      size: 'large',
      text: 'signin_with',
    });
  }, [signInWithGoogle]);

  return (
    <div className="login-screen">
      <div className="card" style={{ textAlign: 'center', minWidth: 320 }}>
        <img src="/logo-192.png" alt="" width="64" height="64" style={{ marginBottom: 8 }} />
        <h2>Pest Plan Manager</h2>
        <p style={{ color: 'var(--color-text-muted)', fontSize: 14 }}>
          Sign in with your pricklypearwildlife.com Google account.
        </p>
        {!GOOGLE_CLIENT_ID && (
          <div className="error-banner">VITE_GOOGLE_OAUTH_CLIENT_ID is not configured in this build.</div>
        )}
        {error && <div className="error-banner">{error}</div>}
        <div ref={buttonRef} style={{ display: 'flex', justifyContent: 'center', marginTop: 12 }} />
      </div>
    </div>
  );
}
